module.exports = __webpack_public_path__ + "media/images/ecommerce/thankyou-50f2e96ff20567a446cdabf47771dc39.svg";